import CommonModal from "@/components/common/CommonModal";
import { Form, Input, Select, Row, Col } from "antd";
import { useEffect } from "react";
import { filterByLabel } from "@/lib/filterByLabel";

interface NotificationRecipientModalProps {
  open: boolean;
  onCancel: () => void;
  onSubmit: (values: any) => void;
  initialData?: any;
  isEditMode?: boolean;
  roleOptions?: any[];
  confirmLoading?: boolean;
}

const NotificationRecipientModal: React.FC<NotificationRecipientModalProps> = ({
  open,
  onCancel,
  onSubmit,
  initialData,
  isEditMode = false,
  roleOptions = [],
  confirmLoading = false,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      if (initialData) {
        form.setFieldsValue({
          receiver_by_document_field: initialData.receiver_by_document_field,
          receiver_by_role: initialData.receiver_by_role,
          condition: initialData.condition,
        });
      } else {
        form.resetFields();
      }
    }
  }, [open, initialData, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      onSubmit(values);
      form.resetFields();
    } catch (error) {
      console.error("Validation failed:", error);
    }
  };

  return (
    <CommonModal
      open={open}
      onCancel={onCancel}
      onOk={handleOk}
      title={isEditMode ? "Edit Recipient" : "Add Recipient"}
      confirmLoading={confirmLoading}
    >
      <Form form={form} layout="vertical">
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="receiver_by_document_field" label="Document Field">
              <Input placeholder="Enter document field" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="receiver_by_role" label="Role">
              <Select
                placeholder="Select role"
                options={roleOptions}
                showSearch
                filterOption={filterByLabel}
              />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item name="condition" label="Condition">
          <Input placeholder="Enter condition" />
        </Form.Item>
      </Form>
    </CommonModal>
  );
};

export default NotificationRecipientModal;
